let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gRwQ3")).then(() => parcelRequire('bQGuP'));